import React from "react";
import "./style.css";
import "antd/dist/antd.css";
import { Tabs } from "antd";
const { TabPane } = Tabs;
export const Entrance = () => {
  return (
    <div className="container">
      <div className="divider"></div>
      <div className="entrance-page">
        <h1 className="section-title text-center fw-500">About Entrance</h1>
        <p className="subtitle-p mt-3">
          Entrance exam of Bachelor of Science in Computer Science & Information
          Technology (Bsc.CSIT) is conducted by Institute of Science and
          Technology (IOST).
        </p>
        <div className="mt-3 fw-500">
          <Tabs defaultActiveKey="1">
            <TabPane tab="Marks Scheme" key="1">
              <div className="my-2 sub-marks">
                <h3 className="fw-500 text-3">
                  Here is a entrance exam's marks scheme for Bsc.CSIT :
                </h3>
                <p className="text-black-accent text-3 fw-400">
                  Physics :<span className="ml-1 text-black text-lato">25</span>
                </p>
                <p className="text-black-accent text-3 fw-400">
                  Mathematics :
                  <span className="ml-1 text-black text-lato">25</span>
                </p>
                <p className="text-black-accent text-3 fw-400">
                  English :<span className="ml-1 text-black text-lato">25</span>
                </p>
                <p className="text-black-accent text-3 fw-400">
                  Chemistry :
                  <span className="ml-1 text-black text-lato">25</span>
                </p>
              </div>
            </TabPane>
            <TabPane tab="Online Test" key="2">
              <div>
                <h3 className="fw-500">
                  Welcome to the online test platfrom. All the best 😀
                </h3>
              </div>
            </TabPane>
            <TabPane tab="Entrance Material" key="3">
              Entrance Resource
            </TabPane>
          </Tabs>
        </div>
      </div>
      <divider />
    </div>
  );
};
